import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "row g-3 align-items-end" }
const _hoisted_4 = {
  key: 0,
  class: "col-md-5"
}
const _hoisted_5 = { class: "col-md-5" }
const _hoisted_6 = { class: "col-md-2 d-flex gap-2" }
const _hoisted_7 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "d-flex justify-content-end mb-15" }
const _hoisted_10 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_11 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_12 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_13 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_14 = {
  key: 0,
  class: "badge rounded-pill fs-13 text-bg-danger"
}
const _hoisted_15 = {
  key: 1,
  class: "badge rounded-pill fs-13 text-bg-info"
}
const _hoisted_16 = {
  key: 2,
  class: "badge rounded-pill fs-13 text-bg-success"
}
const _hoisted_17 = {
  key: 5,
  class: "dropdown"
}
const _hoisted_18 = ["id"]
const _hoisted_19 = ["aria-labelledby"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.user.role_id && _ctx.user.role_id == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-label fw-semibold small text-muted mb-1" }, "Livreur", -1)),
                _createVNode(_component_v_select, {
                  class: "custom-select-height",
                  label: "name",
                  options: _ctx.LivreursList,
                  modelValue: _ctx.liv_filter,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.liv_filter) = $event)),
                  placeholder: "Tous les livreurs"
                }, null, 8, ["options", "modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label fw-semibold small text-muted mb-1" }, "Statut", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-control form-select",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.status_filter) = $event)),
              style: {"height":"38px"}
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("option", { value: "" }, "Tous les statuts", -1),
              _createElementVNode("option", { value: 0 }, "Nouveau", -1),
              _createElementVNode("option", { value: 1 }, "Enregistré", -1),
              _createElementVNode("option", { value: 2 }, "Payé", -1)
            ]), 512), [
              [_vModelSelect, _ctx.status_filter]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "btn btn-primary flex-grow-1",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter()))
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "flaticon-search me-1" }, null, -1)
            ])),
            _createElementVNode("button", {
              class: "btn btn-outline-secondary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.Removefilter())),
              title: "Réinitialiser les filtres"
            }, _cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "flaticon-close" }, null, -1)
            ]))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.user.role_id && _ctx.user.role_id == 4 && _ctx.auth.can('ADD_BP_L'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "btn btn-primary",
                to: { name: 'NewPaymentPage' }
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "flaticon-add me-1" }, null, -1),
                  _createTextVNode(" Ajouter Bon pour Livreur ", -1)
                ])),
                _: 1,
                __: [9]
              }))
            : _createCommentVNode("", true),
          (_ctx.user.role_id && _ctx.user.role_id == 3 && _ctx.auth.can('ADD_BP_L'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "btn btn-primary",
                to: { name: 'NewPaymentModPage' }
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "flaticon-add me-1" }, null, -1),
                  _createTextVNode(" Ajouter Bon pour Livreur ", -1)
                ])),
                _: 1,
                __: [10]
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_vue_good_table, {
          "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Bons Sélectionés',
          disableSelectInfo: true,
        },
          onSelectedRowsChange: _ctx.selectPays,
          onSelectAll: _ctx.onSelectAllPays,
          columns: _ctx.columns,
          rows: _ctx.rows,
          responsive: ""
        }, {
          emptystate: _withCtx(() => _cache[11] || (_cache[11] = [
            _createElementVNode("div", { class: "text-center py-20 text-muted" }, "Aucune entrée correspondante trouvée", -1)
          ])),
          "table-row": _withCtx((props) => [
            (props.column.field === 'note_ref')
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createElementVNode("b", null, _toDisplayString(props.row.note_ref), 1)
                ]))
              : (props.column.field === 'zone_name')
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createTextVNode(_toDisplayString(props.row.zone_name), 1),
                    _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(props.row.agency_name), 1)
                  ]))
                : (props.column.field === 'created_at')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      (props.row.created_at != null)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                            _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(props.row.by_name), 1)
                    ]))
                  : (props.column.field === 'total')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(props.row.total) + " DH ", 1))
                    : (props.column.field === 'statut')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          (props.row.statut == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, " Nouveau "))
                            : (props.row.statut == 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Enregistré "))
                              : (props.row.statut == 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Payé "))
                                : _createCommentVNode("", true)
                        ], 64))
                      : (props.column.field === 'action')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("button", {
                              class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                              type: "button",
                              id: 'dropdownMenuButton-' + props.row.id,
                              "data-bs-toggle": "dropdown",
                              "aria-expanded": "false"
                            }, _cache[14] || (_cache[14] = [
                              _createElementVNode("i", { class: "flaticon-more" }, null, -1)
                            ]), 8, _hoisted_18),
                            _createElementVNode("ul", {
                              class: "dropdown-menu dropdown-menu-end",
                              "aria-labelledby": 'dropdownMenuButton-' + props.row.id
                            }, [
                              (_ctx.auth.can('BP_L'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.openNewWindow(`/edit-payment-note/ref/${props.row.note_ref}`)), ["prevent"])
                                    }, _cache[15] || (_cache[15] = [
                                      _createElementVNode("i", { class: "flaticon-eye me-2" }, null, -1),
                                      _createTextVNode(" Détails du Bon ", -1)
                                    ]), 8, _hoisted_21)
                                  ]))
                                : _createCommentVNode("", true),
                              (props.row.statut == 0 && props.row.total_parcel == 0 && _ctx.auth.can('BP_L'))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.RemoveNote(props.row)), ["prevent"])
                                    }, _cache[16] || (_cache[16] = [
                                      _createElementVNode("i", { class: "flaticon-trash me-2" }, null, -1),
                                      _createTextVNode(" Supprimer le Bon ", -1)
                                    ]), 8, _hoisted_23)
                                  ]))
                                : _createCommentVNode("", true),
                              (props.row.total_parcel != 0)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.GetPDF(props.row)), ["prevent"])
                                    }, _cache[17] || (_cache[17] = [
                                      _createElementVNode("i", { class: "flaticon-download me-2" }, null, -1),
                                      _createTextVNode(" Télécharger le bon ", -1)
                                    ]), 8, _hoisted_25)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_19)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["onSelectedRowsChange", "onSelectAll", "columns", "rows"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users,
          offset: 9,
          onPaginate: _ctx.getRecords
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ])
  ]))
}